<template>
  <div class="popup-lf-test">
    <div class="popup-lf-test__header">
      <p>{{ isResultShown ? "Результат" : "Опрос" }}</p>
      <Icon @click="closePopup" class="icon-Close popup-lf-test__icon" />
    </div>
    <div v-if="!isResultShown" class="popup-lf-test__body">
      <div
        class="popup-lf-test__list"
        v-for="block in LigaForumTest"
        :key="block.model"
      >
        <b>{{ block.title }}</b>
        <TabsRadio v-model="models[block.model]" :tab-data="block.items" />
      </div>
      <div class="popup-lf-test__btn">
        <Button :disabled="isTestDisabled" @click="showResultOrStartOver">
          Показать результат
        </Button>
      </div>
    </div>
    <div v-else class="popup-lf-test__body popup-lf-test__body--result">
      <div class="popup-lf-test__result">
        <p
          v-html="
            testResult.length > 1
              ? 'В тебе есть качества нескольких направлений! Ты можешь выбрать любое из них, там тебе будет хорошо!'
              : LigaForumTracksDescriptions[testResult[0]]
          "
        />

        <div class="popup-lf-test__result-list">
          <div
            v-for="shift in shiftsResult"
            :key="shift.key_liga"
            class="popup-lf-test__result-img"
          >
            <a :href="shift?.url_tg" target="_blank">
              <img :src="shift.logo" :alt="shift.title" />
            </a>

            <span>{{ shift.title }}</span>
          </div>
        </div>
        <Button :disabled="isTestDisabled" @click="showResultOrStartOver">
          Начать заново
        </Button>
      </div>
    </div>
  </div>
</template>
<script>
import Icon from "@/components/Blocks/Icon.vue";
import TabsRadio from "@/components/Blocks/TabsRadio.vue";
import LigaForumTest from "@/enums/LigaForumTest";
import LigaForumTracksDescriptions from "@/enums/LigaForumTracksDescriptions";
import Button from "@/components/Blocks/Button.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "PopupLigaForumTest",
  components: { Button, TabsRadio, Icon },
  data() {
    return {
      models: {},
      isResultShown: false,
      LigaForumTest,
      LigaForumTracksDescriptions,
    };
  },
  methods: {
    closePopup() {
      this.$store.commit("setCurrentPopup", {
        isShown: false,
      });
    },
    closePopupEsc(e) {
      if (e.key === "Escape") this.closePopup();
    },
    showResultOrStartOver() {
      this.isResultShown = !this.isResultShown;
    },
  },
  computed: {
    isTestDisabled() {
      return Object.values(this.models).some((model) => !model);
    },
    testResult() {
      const result = Object.values(this.models).reduce((acc, modelValue) => {
        if (!modelValue) return acc;
        if (!acc[modelValue]) {
          acc[modelValue] = 1;
        } else {
          acc[modelValue] += 1;
        }
        return acc;
      }, {});

      const maxValue = Math.max(...Object.values(result));

      const maxEntries = Object.fromEntries(
        Object.entries(result).filter(([key, value]) => value === maxValue),
      );
      return Object.keys(maxEntries);
    },
    shiftsResult() {
      return this.teams?.info?.data?.filter((team) =>
        this.testResult.includes(team.key_liga),
      );
    },
    ...mapGetters(["teams"]),
  },
  mounted() {
    window.addEventListener("keydown", this.closePopupEsc);
    this.LigaForumTest.forEach((block) => {
      if (!this.models[block.model]) this.models[block.model] = "";
    });
  },
  unmounted() {
    window.removeEventListener("keydown", this.closePopupEsc);
  },
};
</script>

<style lang="scss">
.popup-lf-test {
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    p {
      font-size: 2.4rem;
      line-height: 3rem;
      font-weight: 700;
    }
  }
  &__icon {
    align-self: flex-end;
    cursor: pointer;
    font-size: 1.4rem;
    color: var(--color--disabled);
  }
  &__body {
    overflow-y: auto;
    height: 80vh;
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    &--result {
      justify-content: center;
    }
  }
  &__list {
    display: flex;
    flex-direction: column;
    grid-gap: 10px;
  }
  &__result {
    display: flex;
    flex-direction: column;
    grid-gap: 20px;
    align-items: center;
    white-space: pre-wrap;
    & > p {
      text-align: center;
    }
    &-list {
      display: flex;
      align-items: center;
      grid-gap: 20px 50px;
      justify-content: center;
      flex-wrap: wrap;
      width: 100%;
    }
    &-img {
      display: flex;
      flex-direction: column;
      align-items: center;
      grid-gap: 10px;
      max-width: 120px;
      width: 100%;
      img {
        width: 100%;
        aspect-ratio: 1 / 1;
        transition: all ease-in-out 0.2s;
        cursor: pointer;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
  .tabs-radio__field {
    flex-direction: column;
  }
}
</style>
